import React from 'react';
import { Grid, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import { AdminFieldLabel } from '@/admin/shared/AdminFieldLabel';
import { USER_FIELD_LABELS } from './userFormValues';

/**
 * A labelled text field in the user drawers' Grid, bound to Formik field `name`. Shows its
 * error, or else helperText. sm: its width from the sm breakpoint up. required marks the
 * label with an asterisk; the label has an undo icon once the field changes.
 */
export const UserTextField = ({ name, helperText, sm = 12, required = false }) => {
	const { getFieldProps, touched, errors } = useFormikContext();
	const error = touched[name] && errors[name];
	return (
		<Grid size={{ xs: 12, sm }}>
			<AdminFieldLabel name={name} required={required}>
				{USER_FIELD_LABELS[name]}
			</AdminFieldLabel>
			<TextField
				fullWidth
				{...getFieldProps(name)}
				error={Boolean(error)}
				helperText={error || helperText}
			/>
		</Grid>
	);
};
